<template>
    <div class="py-4">
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <!-- <h1 class="h2 ls-tight">Crecimiento de facturación</h1> -->
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4 text-center">
                    <img :src="maintenance" width="auto" height="300px">
                    <h1 class="h2 ls-tight">Modo mantenimiento!!!</h1>
                    <p>Esta sección está en construcción. ¡Vuelva más tarde!</p>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import maintenance from '@/assets/img/maintenance.svg'
export default {
    data(){
        return {
            maintenance,
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/reports/views/BillingGrowth.vue